import { useForm, Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Props {
  errors?: string[]
}

export default function Register({ errors }: Props) {
  const { data, setData, post, processing } = useForm({
    business_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    tenant_type: '0',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/registrations')
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto mt-20">
        <div className="bg-white p-8 rounded-lg shadow">
          <h1 className="text-2xl font-bold text-[#202020] mb-6 text-center">Crear Cuenta</h1>

          {errors && errors.length > 0 && (
            <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
              {errors.map((error, i) => <p key={i}>{error}</p>)}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del negocio</label>
              <input
                type="text"
                value={data.business_name}
                onChange={(e) => setData('business_name', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de negocio</label>
              <select
                value={data.tenant_type}
                onChange={(e) => setData('tenant_type', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
              >
                <option value="0">Tienda de Productos Varios</option>
                <option value="1">Restaurante/Food Truck/CoffeeShop</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
              <input
                type="password"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
                minLength={6}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar contraseña</label>
              <input
                type="password"
                value={data.password_confirmation}
                onChange={(e) => setData('password_confirmation', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
                minLength={6}
              />
            </div>

            <button
              type="submit"
              disabled={processing}
              className="w-full bg-[#FFC107] text-[#202020] py-2 rounded font-semibold hover:bg-[#e6ad06] transition-colors disabled:opacity-50"
            >
              {processing ? 'Creando cuenta...' : 'Crear cuenta'}
            </button>
          </form>

          <p className="mt-4 text-center text-sm text-gray-600">
            ¿Ya tienes cuenta?{' '}
            <Link href="/session/new" className="text-[#55ACEE] hover:underline">
              Inicia sesión
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  )
}
